(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("H5JSSDK", [], factory);
	else if(typeof exports === 'object')
		exports["H5JSSDK"] = factory();
	else
		root["H5JSSDK"] = factory();
})(window, function() {
return 